import '@/javascripts/effects';
import './career.scss';
import 'flickity-fade';
import sanitizeHTML from 'sanitize-html';
import { Converter } from 'showdown';

import Vue from 'vue';
import testimonial from '@/Vue/testimonialApp';
import socialNetworkIcon from '@/Vue/socialNetworkApp';
import jobOffers from '@/Vue/jobOffersApp';
import footerApp from '@/Vue/footerApp';
import hrTeam from '@/Vue/hrTeamApp';
import benefits from '@/Vue/benefitsApp';
import textWithImage from '@/Vue/textWithImageApp';

import { getContent } from '@/javascripts/contentful';
import { checkDataStructure } from '@/javascripts/checkDataStructure';

// Converter Markdown to Html
const markdown = new Converter();

getContent('3ebxWNpP6TbaLB5S58vbho').then(({ fields }) => {
  // retrieve ctf
  // eslint-disable-next-line no-new
  new Vue({
    el: '#hrTeamApp',
    data: {
      entryId: fields.hrTeam.sys.id,
    },
    components: {
      hrTeam,
    },
  });

  // eslint-disable-next-line no-new
  new Vue({
    el: '#benefitsApp',
    data: {
      entryId: fields.benefits.sys.id,
    },
    components: {
      benefits,
    },
  });

  // eslint-disable-next-line no-new
  new Vue({
    el: '#socialNetworkApp',
    data: {
      entryId: fields.socialNetworks.sys.id,
    },
    components: {
      socialNetworkIcon,
    },
  });

  // eslint-disable-next-line no-new
  new Vue({
    el: '#jobOffersApp',
    data: {
      entryId: fields.jobs.sys.id,
    },
    components: {
      jobOffers,
    },
  });

  // eslint-disable-next-line no-new
  new Vue({
    el: '#testimonialApp',
    data: {
      testimonials: fields.testimonials,
    },
    components: {
      testimonial,
    },
  });

  // eslint-disable-next-line no-new
  new Vue({
    el: '#textWithImageApp',
    data: {
      dataResponse: fields.gppFacts,
    },
    components: {
      textWithImage,
    },
  });

  checkDataStructure(fields.pageId);
  checkDataStructure(fields.hero);
  checkDataStructure(fields.gppFacts);
  checkDataStructure(fields.benefits);
  checkDataStructure(fields.jobs);
  checkDataStructure(fields.speculativeApplication);
  checkDataStructure(fields.testimonials);
  checkDataStructure(fields.socialNetworks);
  checkDataStructure(fields.footer);
});

Vue.prototype.$sanitize = sanitizeHTML;
Vue.prototype.$markdown = markdown;

// eslint-disable-next-line no-new
new Vue({
  el: '#footerApp',
  components: {
    footerApp,
  },
});
